import { render, staticRenderFns } from "./SupplierManualDirForm.vue?vue&type=template&id=5d52ca11&scoped=true&lang=pug&"
import script from "./SupplierManualDirForm.vue?vue&type=script&lang=js&"
export * from "./SupplierManualDirForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplierManualDirForm.vue?vue&type=style&index=0&id=5d52ca11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d52ca11",
  null
  
)

export default component.exports